import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
	selector: 'yesnocancel',
	templateUrl: './yesNoCancelModal.component.html',
	standalone: false,
})
export class YesNoCancelModalComponent {
	private _texts: any = {};
	private _answer: string;

	constructor(
		private bsModalRef: BsModalRef
	) {
	}

	yep(): void {
		this._answer = 'yes';
		this.bsModalRef.hide();
	}

	nope(): void {
		this._answer = 'no';
		this.bsModalRef.hide();
	}

	onCancel(): void {
		this._answer = 'cancel';
		this.bsModalRef.hide();
	}

	get texts(): any {
		return this._texts;
	}

	set texts(newTexts: any) {
		this._texts = newTexts;
	}

	get answer(): string {
		return this._answer;
	}
}
